import messageResource from "../messageResource";
import {AccessRights} from "../constants";
import {escapeHtmlSymbols} from "../atUtils";
import {Feature, isEnabled} from '../features'

class AccessRightsStrategy {
    constructor(id,
                nameKey,
                selectAllMessageKey,
                filterMessageKey,
                userNoRightsMessageKey,
                userNoEmailAndRightsMessageKey,
                noAccessRightGrantedUsersMessageKey,
                noEnabledAccessRightGrantedUsersMessageKey,
                noSelectedNodesHasDisabledOrWithoutAccessRightMessageKey,
                groupEmptyEntityTooltipKey,
                noNotificationAccessRightMessageKey) {
        this.id = id;
        this.nameKey = nameKey;
        this.name = null;
        this.selectAllMessageKey = selectAllMessageKey ?
                                   selectAllMessageKey : "common.users_selector.access_right.select_all";
        this.filterMessageKey = filterMessageKey ?
                                filterMessageKey : "common.users_selector.access_right.show_users_without_right";
        this.userNoRightsMessageKey = userNoRightsMessageKey ?
                                      userNoRightsMessageKey : "common.users_selector.access_right.insufficient_rights";
        this.userNoEmailAndRightsMessageKey = userNoEmailAndRightsMessageKey ?
                                              userNoEmailAndRightsMessageKey : "common.users_selector.access_right.insufficient_rights_without_email";
        this.noAccessRightGrantedUsersMessageKey = noAccessRightGrantedUsersMessageKey ?
                                                   noAccessRightGrantedUsersMessageKey : "users_selector.no_access_right_granted_users";
        this.noEnabledAccessRightGrantedUsersMessageKey = noEnabledAccessRightGrantedUsersMessageKey ?
                                                          noEnabledAccessRightGrantedUsersMessageKey : "users_selector.no_access_right_granted_users_with_enabled_access";
        this.noSelectedNodesHasDisabledOrWithoutAccessRightMessageKey = noSelectedNodesHasDisabledOrWithoutAccessRightMessageKey ?
                                                                        noSelectedNodesHasDisabledOrWithoutAccessRightMessageKey : "users_selector.hide_not_selected.only_disabled_or_without_ar";
        this.groupEmptyEntityTooltipKey = groupEmptyEntityTooltipKey ?
                                          groupEmptyEntityTooltipKey : "users_selector.notifications.expand_collapse_disabled.tooltip";
        this.noNotificationAccessRightMessageKey = noNotificationAccessRightMessageKey ?
                                                   noNotificationAccessRightMessageKey : "mail_notifications.users_selector.no_notification.access_right";
        this.name = this.nameKey ? messageResource.getMessage(this.nameKey) : "";
    }

    getId() {
        return this.id;
    }

    /**
     * Determines whether passed access rights provide privileges
     * @param userRights the set of rights to be verified
     */
    isGranted(userRights) {
        return userRights.indexOf(this.id) !== -1;
    }

    getSelectAllMessage() {
        return messageResource.getMessage(this.selectAllMessageKey, [this.name]);
    }

    getFilterMessage() {
        return messageResource.getMessage(this.filterMessageKey, [this.name]);
    }

    getUserNoRightsMessage() {
        return messageResource.getMessage(this.userNoRightsMessageKey, [this.name]);
    }

    getUserNoEmailAndRightsMessage() {
        return messageResource.getMessage(this.userNoEmailAndRightsMessageKey);
    }


    getNoAccessRightGrantedUsersMessage() {
        return messageResource.getMessage(this.noAccessRightGrantedUsersMessageKey, [escapeHtmlSymbols(this.name)]);
    }

    getNoEnabledAccessRightGrantedUsersMessage() {
        return messageResource.getMessage(this.noEnabledAccessRightGrantedUsersMessageKey, [escapeHtmlSymbols(this.name)]);
    }

    getNoSelectedNodesHasDisabledOrWithoutAccessRightMessage() {
        return messageResource.getMessage(this.noSelectedNodesHasDisabledOrWithoutAccessRightMessageKey, [escapeHtmlSymbols(this.name)]);
    }

    getGroupEmptyEntityTooltip() {
        return messageResource.getMessage(this.groupEmptyEntityTooltipKey, [this.name]);
    }

    getNoNotificationAccessRightMessage(user) {
        return messageResource.getMessage(this.noNotificationAccessRightMessageKey, [user.formatNameFML(), this.name]);
    }

    getName() {
        return this.name;
    }
}

export class SubmitTTRightStrategy extends AccessRightsStrategy {
    constructor() {
        super(AccessRights.SUBMIT_TIME_TRACK,
              "common.users_selector.access_right.submit_time_track");
    }
}

export class GenerateMoneyReportRightStrategy extends AccessRightsStrategy {
    constructor() {
        const isURAEnabled = isEnabled(Feature.URA)
        const isBTYEnabled = isEnabled(Feature.BTY)
        let rightTitleKey = ""
        if (isURAEnabled && isBTYEnabled)
            rightTitleKey = "common.users_selector.access_right.generate_money_reports"
        if (!isURAEnabled && isBTYEnabled)
            rightTitleKey = "common.users_selector.access_right.generate_money_reports_only_billing"
        if (isURAEnabled && !isBTYEnabled)
            rightTitleKey = "common.users_selector.access_right.generate_money_reports_only_cost"
        super(
            AccessRights.GENERATE_MONEY_REPORTS,
            rightTitleKey);
    }
}

export class EditHierarchyRightStrategy extends AccessRightsStrategy {
    constructor() {
        super(
            AccessRights.EDIT_HIERARCHY,
            "common.users_selector.access_right.manage_scope");
    }
}

export class AccessToManagerScopesStrategy extends AccessRightsStrategy {
    constructor() {
        super(
            100,
            "users_selector.access_right.access_to_scope_of_work",
            "users_selector.access_right.access_to_scope_of_work.select_all",
            "users_selector.access_right.access_to_scope_of_work.show_users_without_right",
            "users_selector.access_right.access_to_scope_of_work.insufficient_rights",
            "users_selector.access_right.access_to_scope_of_work.insufficient_rights_without_email",
            "users_selector.access_right.access_to_scope_of_work.no_access_right_granted_users",
            "users_selector.access_right.access_to_scope_of_work.no_access_right_granted_users_with_enabled_access",
            "users_selector.access_right.access_to_scope_of_work.hide_not_selected.only_disabled_or_without_ar",
            "users_selector.access_right.access_to_scope_of_work.expand_collapse_disabled.tooltip",
            "users_selector.access_right.access_to_scope_of_work.no_notification.access_right");
    }

    isGranted(userRights) {
        //TODO[enkov]: use common method
        return userRights.indexOf(AccessRights.MANAGE_USERS) !== -1 ||
               userRights.indexOf(AccessRights.EDIT_HIERARCHY) !== -1 ||
               userRights.indexOf(AccessRights.SUBMIT_OTHER_USER_TIME_TRACK) !== -1 ||
               userRights.indexOf(AccessRights.GENERATE_MONEY_REPORTS) !== -1;
    }
}






// WEBPACK FOOTER //
// ./web/js/notifications/AccessRightsStrategy.js